const baseStyle = {
  opacity: 1,
};

export const Divider = {
  baseStyle,
};
